import React, { useState , useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import db from "../../functions/firestore.js";
import { options, sortMoviesByFilter} from "../../functions/functions.js";
import Movieinfo from "../movie/movieinfo.js";
import LazyLoad from "react-lazyload";


export default function MovieFilters() {
    const [ movies , setMovies] = useState('');
    const [ feelings , setfeelings] = useState([]);
    const [ modalOpen, setModalOpen] = useState(false);
    const [ movieData , setMovieData] = useState('');

    const [filterFeels , setPF] = useState([]);
    const [filterGenre , setPG] = useState([]);
    const [title , setTitle] = useState('');

    const [ loading, setLoading] = useState(false);
    const [ error, setError] = useState('');

    useEffect(() => {
      fetchMovies();
      fetchfeelings();
    }, [filterFeels , filterGenre, loading, error])

    const fetchMovies = async() => {
      await db.collection("movies").where('enes_review', '==', 1).get().then(response => {
        const movielimit = response.size;
        const fetchedMovies = [];
        // MOVIES
        response.docs.forEach(document => {
          db.collection("movies").doc(document.id).collection('mfeelings').get().then(response => {

            //MOVIE FEELINGS
            const fetchedMoviesFeelings = [];
            const fetchedMovieUsers = [];
            response.docs.forEach(document2 => {
              const docData = document2.data();
              fetchedMoviesFeelings.push({name: docData["mfeeling_name"] , icon: docData["mfeeling_icon"]});
              fetchedMovieUsers.push({name: docData["mfeeling_name"] , doc_id: document2.id , userid: docData["user_id"]});
            });

            //SORTING FEELINGS
            const uniqueArray = a => [...new Set(a.map(o => JSON.stringify(o)))].map(s => JSON.parse(s));
            const unique = uniqueArray(fetchedMoviesFeelings);            
            let duplicates = unique.map(value => [{feeling: value, length: fetchedMoviesFeelings.filter(str => str.name === value.name).length}]);
            if(duplicates){ duplicates.sort((a, b) => (a[0].length > b[0].length) ? -1 : 1);  }

            //SORT ALL MOVIE FEELIGNS 

            //COMNING MOVIE DATA AND TOTAL FEELINGS
            var fetchedMovie = {
              id: document.id,
              ...document.data(),
              moviefeelings: duplicates,
              allmoviefeelings: fetchedMovieUsers
            };
            fetchedMovies.push(fetchedMovie);

            if(fetchedMovies.length === movielimit){
              const preferences = sortMoviesByFilter(fetchedMovies , filterFeels, filterGenre);
              //SET STATE
              setMovies([...movies , preferences]);
            }
          });
        });
      }).catch(function(err) {
        setError('Error: Getting movies! Quota exceeded');
      })
    }

    //FETCHING ALL FEELINGS
    const fetchfeelings = async() => {
      await db.collection("feelings").get().then(querySnapshot => {
          const docs = querySnapshot.docs.map(doc => doc.data());
          setfeelings(docs);
      }).catch(function(err) {
        setError('Error: Getting movies! Quota exceeded');
      })
    }

    //GENRE
    const setfilterGenre = (data) => {  
      setLoading(loading, true);

      setPG([...filterGenre , data]);
      
      const filterGenreArray = [];
      filterGenreArray.push(...filterGenre);
      filterGenreArray.push(data);

      const preferences = sortMoviesByFilter(movies , filterFeels, filterGenreArray);
      setMovies(preferences);
      setLoading(loading,false);
    };
    const removefilterGenre = (data) => { 
        const i = filterGenre.findIndex( str => str === data );
        const filterGenreArray = filterGenre.slice(0, i).concat(filterGenre.slice(i + 1, filterGenre.length))
        setPG(filterGenreArray);
        const preferences = sortMoviesByFilter(movies , filterFeels, filterGenreArray);
        setMovies(preferences);
     };  

    //FEELINGS
    const setfilterFeelings = (data) => {  
      setPF([...filterFeels , data]);
      
      const filterFeelsArray = [];
      filterFeelsArray.push(...filterFeels);
      filterFeelsArray.push(data);

      const preferences = sortMoviesByFilter(movies , filterFeelsArray, filterGenre);
      setMovies(preferences);
    };

    const removefilterFeelings = (data) => { 
        const i =filterFeels.findIndex( str => str === data );
        const filterFeelsArray =filterFeels.slice(0, i).concat(filterFeels.slice(i + 1,filterFeels.length))
        setPF(filterFeelsArray)
        const preferences = sortMoviesByFilter(movies , filterFeelsArray, filterGenre);
        setMovies(preferences);
    };

    function handleChange(modalChange) { setModalOpen(modalChange); }
    const openModal = (data) => { setModalOpen(true); setMovieData(data); };

    const onChangeTitle = event => {
      setTitle(event.target.value);
      movies[0].sort((a, b) => b.title.toLowerCase().includes(event.target.value.toLowerCase()) - a.title.toLowerCase().includes(event.target.value.toLowerCase()));
    };
    const removeSearchText = () => {
      setTitle('');
    };

    return ( 
      <div className="container-fluid">
        {error?
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <div className="alert alert-danger alert-box" role="alert">
                <h4 className="alert-heading">Error loading!</h4>
                <p style={{color: '#155724'}}>{error}</p>
                <hr />
                <p style={{color: '#155724'}} className="mb-0">Fixing issues in progress.</p>
              </div>
            </div>
          </div>
        :
          <div className="row">
              <div className="col-12 category text-center">
              <h3>Filter category:</h3>
              {
                options && options.map(data=>{
                    let disabled = '';
                    if(filterGenre){
                        disabled = filterGenre.filter( str => str === data.value )
                    }
                    if(disabled && disabled.length){
                        return(<a onClick={(e) => {  e.preventDefault();  removefilterGenre(data.value) }} className="active"> <img src={require(`../../images/${data.image}`)} alt={data.value}/> <div> <FontAwesomeIcon icon={["fas", "check-circle"]}  /> </div></a>)
                    }else{
                        return(<a className="card" onClick={(e) => { e.preventDefault(); setfilterGenre(data.value) }}> <img src={require(`../../images/${data.image}`)} alt={data.value}/></a>)
                    }
                })
                }
              </div>
              <div className="col-6 moodfilter offset-3 text-center">
              <h3>Filter mood:</h3>
              {
                feelings && feelings.map(data=>{
                    let disabled = '';
                    if(filterFeels){
                        disabled =filterFeels.filter( str => str === data.feeling_name )
                    }
                    if(disabled && disabled.length){
                        return(<a onClick={() => { removefilterFeelings(data.feeling_name)}} className="active"> <h5>{data.feeling_name} <FontAwesomeIcon icon={["fas", "check-circle"]}  />  </h5> </a>)
                    }else{
                        return(<a onClick={(e) => { e.preventDefault(); setfilterFeelings(data.feeling_name) }}> <h5>{data.feeling_name} <FontAwesomeIcon icon={["fas", "check-circle"]}  /></h5></a>)
                    }
                })
                }
              </div>
          </div>
        }
        {!error &&
        <div className="row" style={{marginRight: '15px', marginTop: '100px'}}>
          <div className="col-2 offset-10 text-right searchinput">
            <span className="icon-search"><FontAwesomeIcon icon={["fas", "search"]}  /> </span>
            <input type="text" name="searchInput" placeholder="" onChange={onChangeTitle}  value={title} maxLength="80" placeholder="Title" />
            { title &&
            <span className="icon-close" onClick={removeSearchText}><FontAwesomeIcon icon={["fas", "times"]}  /> </span>
            }
          </div>
        </div>
        }

        <div className="movies">
        <Movieinfo modalvisible = {modalOpen} data = {movieData} datafeelings = {feelings} onChange={handleChange} />

          {loading? 
            <span>
              Loading
            </span>
            : 
            <div className = "row rowmovies">
            {
              movies[0] && movies[0].map(data=>{
                return(
                <div key={data.id} className="preview">
                  <a href="#" onClick={(e) => { e.preventDefault(); openModal(data); }}>
                    {data.procentege > 0 ?
                      <img className="card" src={data.movie_thumbnail} />
                    :  
                      <LazyLoad height={192} width={341} once><img className="card" src={data.movie_thumbnail} /></LazyLoad>
                    }
                  </a>
                  <h4 className="text-center">{data.title} ({data.procentege} %)</h4>
                </div>
                )
              })
            }
            </div>
          }
        </div>
      </div>
    )
}




  